import {
  Component,
  EventEmitter,
  HostBinding,
  inject,
  Injector,
  Input,
  Output,
  runInInjectionContext,
  ViewChild,
} from '@angular/core';
import {
  retriveCurrentRouteData,
  SiaBasePdfViewerComponent,
  SiaNewRouterService,
  SiaSizeDetectorService,
  SiaWindowSize,
} from '@sia/shared';
import { Subscription } from 'rxjs';

@Component({
  selector: 'sia-pdf-viewer',
  templateUrl: './sia-pdf-viewer.component.html',
  styleUrls: ['./sia-pdf-viewer.component.css'],
  standalone: true,
  imports: [SiaBasePdfViewerComponent],
})
export class SiaPdfViewerComponent {
  @ViewChild(SiaBasePdfViewerComponent)
  baseViewer!: SiaBasePdfViewerComponent;

  private sizeDetectorService = inject(SiaSizeDetectorService);
  #routerService = inject(SiaNewRouterService);
  #injector = inject(Injector);
  #subs: Subscription[] = [];

  pageData: any = {};
  size: SiaWindowSize | null = null;

  @HostBinding('class.popup')
  isPopup = false;

  @Input() file: Blob | File | null | undefined;
  @Input() initialZoom: number = 1;

  @Output() matchesCountChange = new EventEmitter<{
    current: number;
    total: number;
  }>();

  constructor() {}

  ngOnInit(): void {
    let s0 = this.#routerService.routeChanged$.subscribe(() => {
      var pageData: any = null;
      runInInjectionContext(this.#injector, () => {
        pageData = retriveCurrentRouteData() ?? {};
      });
      if (!pageData?.guid || pageData?.guid == this.pageData?.guid) {
        return;
      }
      this.pageData = pageData;
      this.isPopup = this.pageData.outlet == 'popup';
    });
    this.#subs.push(s0);
  }

  ngAfterViewInit(): void {
    this.size = this.sizeDetectorService.currentSize;
  }

  ngOnDestroy(): void {
    this.#subs.forEach((s) => s.unsubscribe());
  }

  search(query: string, type: 'find' | 'findagain' = 'find', previous: boolean = false) {
    this.baseViewer?.search(query, type, previous);
  }
}
